<div class="nav-lmo">
  <div class="menu-items" *saAllowedAccountRoles="['viewOnly']">
    <div class="groups">
      <div class="group">
        <a routerLink="/lmo/frac/list" routerLinkActive="true" (click)="clickLink()">
          <img
            class="iconImage"
            src="../../../assets/icons/lmo-rig.svg"
            [matTooltip]="'Wells'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Wells</span>
        </a>
        <span class="fake-link" (click)="showIntercom()">
          <i
            class="material-icons"
            [matTooltip]="'Contact Support'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >chat</i
          >
          <span class="label" *ngIf="expanded">Contact Support</span>
        </span>
      </div>
    </div>
  </div>
  <div class="menu-items" *saAllowedAccountRoles="['default', 'sandCoordinator']">
    <div class="groups">
      <div class="group">
        <a routerLink="/lmo/frac/list" routerLinkActive="true" (click)="clickLink()">
          <img
            class="iconImage"
            src="../../../assets/icons/lmo-rig.svg"
            [matTooltip]="'Wells'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Wells</span>
        </a>
        <a routerLink="/notifications" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Notifications'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >email</i
          >
          <span class="label">Notifications</span>
        </a>
        <span class="fake-link" (click)="showIntercom()">
          <i
            class="material-icons"
            [matTooltip]="'Contact Support'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >chat</i
          >
          <span class="label" *ngIf="expanded">Contact Support</span>
        </span>
      </div>
    </div>
  </div>
  <div class="menu-items" *saAllowedAccountRoles="['admin', 'dispatcher']">
    <div class="groups">
      <div class="group">
        <a routerLink="/lmo/frac/list" routerLinkActive="true" (click)="clickLink()">
          <img
            class="iconImage"
            src="../../../assets/icons/lmo-rig.svg"
            [matTooltip]="'Wells'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Wells</span>
        </a>
        <a routerLink="/lmo/loaders" routerLinkActive="true" (click)="clickLink()">
          <img
            class="iconImage"
            src="../../../assets/icons/loader.svg"
            [matTooltip]="'Loaders'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Loaders</span>
        </a>
        <a routerLink="/restrictions" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Restrictions'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >not_interested</i
          >
          <span class="label">Restrictions</span>
        </a>
        <a routerLink="/trucking-contracts" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Trucking Contracts'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >local_shipping</i
          >
          <span class="label">Trucking Contracts</span>
        </a>
        <a
          *saFeatureFlag="'lmoManageSubcarrierContracts'"
          routerLink="/subcarrier"
          routerLinkActive="true"
          (click)="clickLink()"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/subcarrier-contracts.png"
            [matTooltip]="'Subcarrier'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Subcarrier</span>
        </a>
        <a [routerLink]="['/loader-integration-v2']" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Loader Integration'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >data_thresholding</i
          >
          <span class="label">Loader Integration</span>
        </a>
        <a
          [routerLink]="['/lmo/purchase_order']"
          routerLinkActive="true"
          (click)="clickLink()"
          *saFeatureFlag="'purchaseOrderDashboard'"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/purchase-order.svg"
            [matTooltip]="'Purchase Orders'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Purchase Orders</span>
        </a>
        <a routerLink="/invoicing/orders_list/not_billed" routerLinkActive="true" (click)="clickLink()">
          <i class="material-icons" [matTooltip]="'Billing'" [matTooltipShowDelay]="600" [matTooltipPosition]="'right'"
            >attach_money</i
          >
          <span class="label">Billing</span>
        </a>
        <a routerLink="/billing" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Billing By Frac'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >account_balance</i
          >
          <span class="label">Billing By Frac</span>
        </a>
        <a
          routerLink="/lmo/kpi_dashboard"
          routerLinkActive="true"
          (click)="clickLink()"
          *saFeatureFlag="'showKPIDashboardNav'"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/dashboard.svg"
            [matTooltip]="'KPI Dashboard'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">KPI Dashboard</span>
        </a>
        <span class="fake-link" saOrderSearch>
          <i
            class="material-icons"
            [matTooltip]="'Load Lookup'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >search</i
          >
          <span class="label">Load Lookup <span class="note">(Ctrl+Enter)</span></span>
        </span>
        <a routerLink="/notifications" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Notifications'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >email</i
          >
          <span class="label">Notifications</span>
        </a>
        <a routerLink="/bulk-export" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Bulk Export'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >get_app</i
          >
          <span class="label">Bulk Export</span>
        </a>
        <a
          *saFeatureFlag="'showCustomizableBulkExport'"
          routerLink="/bulk-export-v2"
          routerLinkActive="true"
          (click)="clickLink()"
        >
          <i
            class="material-icons"
            [matTooltip]="'Bulk Export'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >get_app</i
          >
          <span class="label">Customizable Bulk Export</span>
        </a>
        <a
          *saFeatureFlag="'showManageBoxPickupSites'"
          routerLink="/box-pickup-sites"
          routerLinkActive="true"
          (click)="clickLink()"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/box_pickup_light.svg"
            [matTooltip]="'Box Pickup Sites'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Box Pickup Sites</span>
        </a>
        <a *ngIf="!isCrewLeader" routerLink="/users" routerLinkActive="true" (click)="clickLink()">
          <i class="material-icons" [matTooltip]="'Team'" [matTooltipShowDelay]="600" [matTooltipPosition]="'right'"
            >people</i
          >
          <span class="label">Team</span>
        </a>
        <a
          *ngIf="userService.bonusEventEnabled()"
          routerLink="/bonus-event"
          routerLinkActive="true"
          (click)="clickLink()"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/bonus-nav.svg"
            [matTooltip]="'Bonus'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Bonus</span>
        </a>
        <a
          *saFeatureFlag="'showTrailerManagement'"
          routerLink="/trailer-management"
          routerLinkActive="true"
          (click)="clickLink()"
        >
          <img
            class="iconImage"
            src="../../../assets/icons/trailer-management.svg"
            [matTooltip]="'Trailer Management'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
          />
          <span class="label">Trailer Management</span>
        </a>
        <a [routerLink]="['/billing/settings']" routerLinkActive="true" (click)="clickLink()">
          <i
            class="material-icons"
            [matTooltip]="'Billing Configuration'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >settings</i
          >
          <span class="label">Billing Configuration</span>
        </a>
        <span class="fake-link" (click)="showIntercom()">
          <i
            class="material-icons"
            [matTooltip]="'Contact Support'"
            [matTooltipShowDelay]="600"
            [matTooltipPosition]="'right'"
            >chat</i
          >
          <span class="label">Contact Support</span>
        </span>
      </div>
    </div>
  </div>
  <div class="bottom-nav" *ngIf="expanded">
    <div class="user">
      <div class="user-info font-medium">
        <div class="user-email">
          {{ userLabel.email || userLabel.name || 'Unknown' }}
        </div>

        <div class="user-company">
          <span *ngIf="isAdmin" class="role">Admin • </span>
          <span *ngIf="isDefault" class="role">Standard • </span>
          <span *ngIf="isViewOnly" class="role">View Only • </span>
          <span *ngIf="isSandCoordinator" class="role">Sand Coordinator • </span>
          <span *ngIf="isDispatcher" class="role">Dispatcher • </span>{{ userLabel.account || 'Unknown' }}
        </div>
      </div>
      <img class="logout" src="../../../assets/icons/signout.svg" alt="signout" (click)="logout()" />
    </div>
  </div>
</div>
